// extracted by mini-css-extract-plugin
module.exports = {"product":"TopSellingProduct_product__27lSr","productDescription":"TopSellingProduct_productDescription__3lSGJ"};